import React, { useEffect } from 'react';

export default function App() {
  useEffect(() => {
    // 1. Set Tab Title
    document.title = "Ottawa Valley VC";

    // 2. Replace React Favicon with a clean black square
    let favicon = document.querySelector("link[rel~='icon']");
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.href = "data:image/svg+xml,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22><rect width=%22100%22 height=%22100%22 fill=%22black%22/></svg>";
  }, []);

  return (
    <div className="relative min-h-screen bg-black overflow-hidden flex flex-col justify-between selection:bg-purple-900 selection:text-yellow-100">
      
      {}
      <style dangerouslySetInnerHTML={{__html: `
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500&family=Playfair+Display:wght@400;600&display=swap');

        .font-sans { font-family: 'Inter', sans-serif; }
        .font-serif { font-family: 'Playfair Display', serif; }

        .bg-image {
          position: absolute;
          inset: 0;
          background-image: url('https://images.unsplash.com/photo-1549449887-f875323c9ce0?q=80&w=2500&auto=format&fit=crop');
          background-size: cover;
          background-position: center;
          filter: brightness(0.3) contrast(1.2) grayscale(0.2);
          z-index: 0;
          transform: scale(1.05);
          animation: slowPan 40s ease-in-out infinite alternate;
        }

        @keyframes slowPan {
          0% { transform: scale(1.05) translate(0, 0); }
          100% { transform: scale(1.1) translate(-2%, -1%); }
        }

        /* Gold to Purple Metallic Gradient */
        .text-gradient-gold-purple {
          background: linear-gradient(135deg, #f3e5c8 0%, #d4af37 35%, #8b5cf6 75%, #4c1d95 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      `}} />

      {}
      {/* Background Image */}
      <div className="bg-image" />

      {/* Complex Overlay: Black to Purple gradient mapping */}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-black/40 via-purple-950/40 to-black/95 mix-blend-multiply" />
      
      {/* Ambient Orbs to give that mysterious, glowing a16z vibe */}
      <div className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] bg-purple-900/20 rounded-full blur-[120px] z-10 pointer-events-none" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[60vw] h-[60vw] bg-yellow-700/10 rounded-full blur-[150px] z-10 pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80vw] h-[40vw] bg-black/60 rounded-full blur-[100px] z-10 pointer-events-none" />

      {}
      <header className="w-full p-8 md:p-12 flex justify-center items-center z-20">
        <div className="text-center">
          <h1 className="text-sm md:text-base font-sans font-light tracking-[0.3em] text-white uppercase">
            OttawaValley
          </h1>
          <p className="text-[0.6rem] md:text-xs font-sans tracking-[0.4em] text-white/40 uppercase mt-2">
            Venture Capital
          </p>
        </div>
      </header>

      {}
      <main className="flex-1 flex flex-col justify-center items-center px-6 md:px-16 lg:px-24 z-20 text-center w-full">
        <div className="max-w-6xl w-full flex flex-col items-center">
          
          {/* Subtle North Hook */}
          <div className="mb-6 md:mb-8 flex items-center gap-4 opacity-70">
            <div className="h-[1px] w-8 md:w-16 bg-gradient-to-r from-transparent to-yellow-500/50" />
            <p className="text-white/70 font-sans tracking-[0.3em] md:tracking-[0.4em] uppercase text-xs md:text-sm whitespace-nowrap">
              The True North Strong & Technical
            </p>
            <div className="h-[1px] w-8 md:w-16 bg-gradient-to-l from-transparent to-purple-500/50" />
          </div>
          
          {/* Massive Cinematic Headline */}
          <h2 className="font-serif text-6xl md:text-8xl lg:text-[10rem] mb-12 text-gradient-gold-purple tracking-tighter leading-[1.05] drop-shadow-2xl">
            IT'S TIME<br />TO REBUILD.
          </h2>
          
          {/* Simple Coming Soon Indicator */}
          <div className="mt-8 md:mt-12 flex flex-col items-center gap-4">
            <div className="w-[1px] h-12 md:h-16 bg-gradient-to-b from-white/20 to-transparent" />
            <p className="text-xs md:text-sm font-sans font-light tracking-[0.5em] text-white/50 uppercase">
              Coming Soon
            </p>
          </div>

        </div>
      </main>

      {}
      <footer className="w-full p-8 md:p-12 flex justify-center items-center z-20">
        <p className="text-[0.6rem] font-sans text-white/30 font-light tracking-[0.2em] uppercase">
          &copy; {new Date().getFullYear()} OttawaValley.VC // Confidential
        </p>
      </footer>

    </div>
  );
}